import clsx from 'clsx';
import styles from './AIText.module.scss';

type AITextProps = {
    text: React.ReactNode;
    style?: React.CSSProperties;
    showLoadingDots?: boolean;
    loadingDotsStyle?: React.CSSProperties;
    animate?: boolean;
};

const AIText = (props: AITextProps) => {
    const { text, style, loadingDotsStyle, showLoadingDots, animate = true } = props;
    return (
        <span className={styles.AIWrapper}>
            <div style={style} className={clsx(styles.AIText, animate && styles.animate)}>
                {text}
            </div>
            {showLoadingDots && (
                <span style={loadingDotsStyle} className={styles.LoadingDots}>
                    ...
                </span>
            )}
        </span>
    );
};

export default AIText;
